export const enum KeyCode {
    ARROW_DOWN_KEY_CODE = 40,
    ARROW_UP_KEY_CODE = 38,
    RETURN_KEY_CODE = 13,
    BACKSPACE_KEY_CODE = 8
}


// WEBPACK FOOTER //
// ./src/Components/Autocomplete/KeyCode.ts